<template>
  <div class="min-height-for-section w-100 pt-livetv">
    <div class="container-fluid">
      <div class="row mt-0 mt-md-4 mx-md-3 mb-3 px-md-2 py-4 remove_m_p">
        <div class="col-12 col-md-12 col-lg-8 px-0 px-md-2">
          <div
            class="embed-responsive embed-responsive-16by9"
            style="border-radius: 8px;"
          >
            <div
              id="vidBox"
              class="player embed-responsive-item"
              ref="vidBox"
            ></div>
          </div>
          <div class="w-100 mt-4">
            <div class="w-100 mb-4 mb-sm-0" ref="vidDetails">
              <p v-if="eps_title" class="eps_player_title mt-3 mb-3">
                {{ eps_title }}
              </p>
              <p
                v-if="eps_desc"
                class="eps mb-2"
                v-html="eps_desc.replace(/(?:\r\n|\r|\n|\n\n)/g, '<br />')"
              ></p>
              <div class="mt-4">
                <div
                  class="sharebtndiv d-flex flex-row align-items-center"
                  @click="openModal(channel_title)"
                >
                  <span class="mr-2">SHARE</span>
                  <img src="@/assets/icon/share.svg" />
                </div>
                <social ref="social"></social>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 px-0 px-md-2 d-none d-lg-block">
          <BillboardBannerTop v-if="desktop"></BillboardBannerTop>
        </div>
      </div>
      <div
        class="row my-4 pb-4 px-2 px-md-4 justify-content-center justify-content-md-start"
        v-if="vod_episodes_related.length > 0"
      >
        <div class="col-12">
          <p class="mainEpsTitle text-left">More Episodes</p>
        </div>
        <div
          class="col-6 col-md-4 col-lg-3 my-3 px-1 px-md-2"
          v-for="(items, index) in pageOfItems"
          :key="items ? items.id : 'none' + index"
        >
          <VodCard
            :image="imgFiltering(items)"
            :imageFeature="imgFiltering(items, 'feature')"
            :latestTag="formatTimestamp(items.dateAvailability)"
            :title="formatString(items.longTitle)"
            :description="items.data.description"
            :link="checkLink(items)"
          />
        </div>
        <div class="col-12 px-0 mt-3">
          <vue-paginate-al
            :totalPage="totalPage"
            @btnClick="goToFunction"
            :nextText="'Next'"
            :prevText="'Prev'"
          ></vue-paginate-al>
        </div>
      </div>
    </div>
    <div class="container-fluid px-2 px-md-4 pb-5 overflow-hidden">
      <VodPlayerSuggestion />
    </div>
    <!-- ads mid -->
    <!-- ads -->
    <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
    <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeaderType.vue";
import noimage from "../assets/noimage.png";
import social from "../components/popup/sharepopup";
import { bus } from "../main";
import axios from "axios";
// ads
import BillboardBannerTop from "../components/ads/v2/vodPlayer/billboardBannerTop.vue";
import BillboardBannerBottom from "../components/ads/v2/vodPlayer/billboardBannerMiddle.vue";
import MrecBannerBottom from "../components/ads/v2/vod/mrecBannerBottom.vue";
import VodPlayerSuggestion from "../components/vodplayer/vodPlayerSuggestion.vue";
import VodCard from "../components/cards/v2/vodCardStatic.vue";

const customLabels = {
  first: "",
  last: "",
  previous: "Previous",
  next: "Next",
};

export default {
  components: {
    social,
    BillboardBannerTop,
    BillboardBannerBottom,
    MrecBannerBottom,
    BreadCrumbsHeader,
    VodPlayerSuggestion,
    VodCard,
  },
  data: function() {
    return {
      embed_url: "",
      active_id: "",
      eps_title: "",
      long_title: "",
      eps_desc: "",
      leftColStyles: {},
      epsColStyles: {},
      schema: this.$route.query.scheme,
      playlist_list: this.$route.query.p_type,
      id: this.$route.query.id,
      eps_id: this.$route.query.eps_id,
      vod: [],
      vod_related: [],
      vod_episodes: [],
      vod_episodes_related: [],
      showepisodelist: true,
      window: {
        width: 0,
        height: 0,
      },
      share: [],
      url: "",
      childDataLoaded: false,
      showModal: false,
      program_title: "",
      tablet: false,
      mobile: false,
      desktop: false,
      category: "",
      category_link: "",
      customLabels,
      pageOfItems: [],
      limit: 12,
      offset: 0,
      totalEpisodeCount: 0,
      totalPage: 0,
      isShowingPagination: false,
    };
  },
  created: function() {
    this.$nextTick(function() {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    $("#vidBox").empty();
    // peer5.destroy();
  },
  methods: {
    paginateEpisodes() {
      const start = this.offset;
      const end = this.offset + this.limit;
      this.pageOfItems = this.vod_episodes_related.slice(start, end);
    },

    goToFunction(page) {
      this.offset = (page - 1) * this.limit;
      this.paginateEpisodes();
    },

    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    openModal() {
      this.share = {
        url: this.url,
        title: this.eps_title,
      };

      bus.$emit("shareVar", this.share);
      this.$refs.social.show();
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      }

      return link;
    },

    playVid(items) {
      var newschema;

      if (items.idSchema == "206") {
        newschema = "205";
        this.$router.push(
          "/play?scheme=" +
            newschema +
            "&p_type=true&id=" +
            this.$route.query.id +
            "&eps_id=" +
            items.id
        );
      } else if (items.idSchema == "208") {
        newschema = "207";
        this.$router.push(
          "/play?scheme=" +
            newschema +
            "&p_type=true&id=" +
            this.$route.query.id +
            "&eps_id=" +
            items.id
        );
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      var heightString = this.$refs.vidBox.clientHeight;
      var vidDetailsString = this.$refs.vidDetails.clientHeight;
      var result = heightString + vidDetailsString + "px";
      var eps_result = (result - 70) / 3 + "px";
      if (this.window.width <= "991") {
        Vue.set(this.leftColStyles, "height", "300px");
      } else {
        Vue.set(this.leftColStyles, "height", result);
        Vue.set(this.epsColStyles, "height", eps_result);
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.settings.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    imgFiltering(item, type = null) {
      let imgurl;
      const hasThumb =
        item.data && item.data.images && item.data.images.thumbnail;
      const hasTitle = item.data && item.data.images && item.data.images.title;
      const hasFeature =
        item.data && item.data.images && item.data.images.feature;

      // First try to get the specifically requested type if it exists
      if (type === "thumbnail" && hasThumb) {
        imgurl =
          "https://rtb.glueapi.io/v1/content/" + item.id + "/image/320x0/images.thumbnail";
      } else if (type === "title" && hasTitle) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" + item.data.images.title.path;
      } else if (type === "feature" && hasFeature) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.feature.path;
      }
      // Fall back to original hierarchy if requested type doesn't exist or no type specified
      else {
        if (hasThumb) {
          imgurl =
            "https://rtb.glueapi.io/v1/content/" + item.id + "/image/320x0/images.thumbnail";
        } else if (hasTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else if (hasFeature) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.feature.path;
        } else {
          imgurl =
            "https://rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },

    initializecontentview() {
      var self = this;
      var token = localStorage.getItem("token");

      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-AUTH-TOKEN": `${token}`,
        },
        data: JSON.stringify({
          idContent: self.active_id, // Content ID from content api response
          contentTitle: self.eps_title, // Content Longtitle from content api response
          site: "RTBGo",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          //console.log(data);
        },
        failure: function(errMsg) {
          //console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "vodplayer",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          // console.log(errMsg);
        },
      });
    },
    PlayerInit(value) {
      //   console.log("in player init");
      var target = this.$refs.vidBox || document.getElementById("vidBox");
      if (!target) {
        this.$nextTick(() => this.PlayerInit(value));
        return;
      }
      var gluePlayer = new GluePlyr();
      gluePlayer.setup(value, {
        apiPath: "https://rtb.glueapi.io",
        target: target,
        poster:
          "https://rtb.glueapi.io/v1/content/" +
          value +
          "/image/1200x0/images.thumbnail?quality=100", //Replace with the id 413 with the id of the content
        site: "RTB",
        // psa: true,
        data: {
          idUser: localStorage.getItem("user_id"),
        },
        type: "video", // video or audio
        playerMode: "vod",
        // casting: "D6AD19DD",
        skin: "0", // false or title (Tile Skin is used for creating player with title image
        ads: {
          enabled: true,
          tagUrl:
            "https://pubads.g.doubleclick.net/gampad/ads?iu=/22163595876/RTBGo_Web_Preroll_VOD&description_url=https%3A%2F%2Fwww.rtbgo.bn%2F&tfcd=0&npa=0&sz=400x300%7C640x480%7C1920x1080&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=",
          contentType: "ondemand",
          cmsid: "glue",
          vid: value,
          keywords: "",
        },
      });

      window.gluePlayer = gluePlayer;
      this.childDataLoaded = true;
    },

    filterFolderData(obj) {
      if (obj.data["program-episode"] && obj.data["program-episode"][0]) {
        this.getFirstContentData(obj.data["program-episode"][0].id);
        if (obj.data["program-episode"]) {
          this.getEpsListContentData(obj.data["program-episode"]);
        }
      } else {
        this.setFirstIditems(obj);
        if (obj.data.program) {
          this.getContentOtherFolderData(obj.data.program.id);
        } else if (obj.data.news) {
          this.getContentOtherFolderData(obj.data.news.id);
        }
      }

      //for other episode list
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    setFirstIditems(obj) {
      this.PlayerInit(obj.id);
      this.program_title = obj.title;
      this.active_id = obj.id;
      this.url = window.location.origin + this.$route.fullPath;
      this.eps_desc = obj.data.description;
      this.eps_title = obj.title;
      this.long_title = obj.longTitle;

      if (
        obj.data.content_type[0] &&
        obj.data.content_type[0].title &&
        obj.data.content_type[0].title.en_US
      ) {
        this.category = obj.data.content_type[0].title.en_US;
        var category_id = obj.data.content_type[0].id;
        this.category_link = `/viewall?cat=${this.convertStringToLower(
          this.category.replace(/\s/g, "")
        )}&contenttype=vod&cat_id=${category_id}`;
        // console.log();
      }

      if (this.active_id && this.eps_desc) {
        this.initializecontentview();
        this.initializepageview();
      }
    },

    filterOtherFolderData(obj) {
      if (obj.data["program-episode"]) {
        this.getEpsListContentData(obj.data["program-episode"]);
      } else if (obj.data["news-episode"]) {
        this.getEpsListContentData(obj.data["news-episode"]);
      }
    },

    async getContentOtherFolderData(value) {
      try {
        axios
          .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
          .then((response) => {
            this.filterOtherFolderData(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },

    async getContentFolderData(value) {
      try {
        axios
          .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
          .then((response) => {
            this.filterFolderData(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },

    async getEpsListContentData(list) {
      let vm = this;
      let promises = [];

      list.forEach(function(items) {
        const myUrl = `https://rtb.glueapi.io/v1/content/${
          items.id
        }?format=json`;
        promises.push(axios.get(myUrl));
      });

      Promise.all(promises).then(function(results) {
        results.forEach(function(response, index) {
          const res = response.data.data;
          if (res) {
            vm.vod_episodes_related.push(response.data.data);
          }

          if (index == results.length - 1) {
            vm.vod_episodes_related.sort(function(a, b) {
              return b.id - a.id;
            });
          }
        });
      });
    },

    async getDirectContentData(value) {
      axios
        .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
        .then((response) => {
          this.filterFolderData(response.data.data);
        });
    },

    async getFirstContentData(value) {
      axios
        .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
        .then((response) => {
          this.setFirstIditems(response.data.data);
        });
    },

    async initializeContentForStart() {
      if (this.playlist_list) {
        if (this.eps_id) {
          this.getDirectContentData(this.eps_id);
        } else {
          this.getContentFolderData(this.id);
        }
      } else {
        this.getFirstContentData(this.id);
      }

      //first skali check for p_type, klu true, ada playlist, klu false, untuk schema yg history
      //second,if p_type true, check plk eps_id,klu ada,direct ke eps id,klu xde,call general,get the first one
      //third, set this.vod and this.vod_episode
    },
  },
  beforeMount() {
    this.initializeContentForStart();
  },
  mounted() {
    var vm = this;
    vm.deviceCheck();
    vm.$nextTick(function() {
      vm.handleResize();
    });

    Vue.nextTick(
      function() {
        setTimeout(
          function() {
            if (vm.vod_episodes_related.length > 0) {
              vm.totalPage = Math.ceil(
                vm.vod_episodes_related.length / vm.limit
              );
              vm.paginateEpisodes();
            }
          }.bind(vm),
          1800
        );
        if (vm.vod) {
        }
      }.bind(vm)
    );
  },
  computed: {
    initPeer() {
      // Our fancy notification (2).
      // peer5
      // peer5.destroy();
      // peer5.init();
    },
  },
};
</script>

<style scoped>
.mb_controller {
  margin-bottom: 80px;
}
.pt-livetv {
  padding: 20px 0 90px;
  font-family: "Poppins", sans-serif !important;
}
.breadCrumbsWrapper {
  padding: 15px 16px 30px;
}
.bg {
  background: #292929;
  height: auto !important; /* cross-browser */
  height: 100%; /* cross-browser */
  /* margin-bottom: 120px; */
}
.p {
  padding: 0;
  margin: 0;
}
.mainEpsTitle {
  font-family: "Poppins", sans-serif !important;
  font-size: 25px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
/* .bg_header {
  background: url("../assets/coming-soon-banner.png");
  background-size: cover;
} */
.bg_header {
  background: url("../assets/headerbg.png");
  background-size: cover;
}
.bg_text {
  font-size: 45px;
  font-weight: bold;
  font-family: "Poppins", sans-serif !important;
  line-height: 1.2;
  letter-spacing: 1.75px;
  text-align: center;
  color: #ffffff;
}
.channel_logo {
  padding: 20px 0px;
}
h4 {
  color: #fab900;
  font-size: 16px;
  font-weight: bold;
  font-family: "Poppins", sans-serif !important;
  line-height: 1.25;
  text-align: center;
}
.title_header {
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: 0.6px;
  text-align: left;
  color: #fab900;
  font-family: "Poppins", sans-serif !important;
}
.title_eps {
  width: 100%;
  font-family: "Poppins", sans-serif !important;
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: 0.32px;
  text-align: left;
  color: #fab900;
  padding: 0;
  margin: 0 0 3px;
}
.eps {
  width: 100%;
  font-size: 16px;
  font-family: "Poppins", sans-serif !important;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #cccccc;
  padding: 0;
  margin: 0 0 3px;
}
.eps_player_title {
  font-size: 24px;
  font-weight: bold;
  font-family: "Poppins", sans-serif !important;
  line-height: 1.2;
  letter-spacing: 0.5px;
  text-align: left;
  color: #e2a802;
  padding: 0;
  margin: 15px 0 3px;
}
.c-p {
  cursor: pointer;
}
.vod_icon {
  width: 44px;
  height: 44px;
  background: #fab900;
  border-radius: 50%;
  display: flex;
  align-items: center;
}
.vod_icon_eps {
  width: 70px;
  height: 70px;
  background: #fab900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.active {
  background: #292929;
}
.item {
  cursor: pointer;
}
.item .item_img {
  width: 100%;
  /* border: 1px solid #fab900; */
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  z-index: 1;
}
.item .item_img img {
  /* width: 100%;
  border-radius: 4px;
  overflow: hidden; */
  background: 100%;
  width: 120%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}

.sharebtndiv {
  cursor: pointer;
}
.sharebtndiv span {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  color: #facb43;
}
.sharebtndiv img {
  width: 20px;
}
@media screen and (max-width: 991px) {
  .remove_m_p {
    padding: 0;
    margin: 0;
  }
}
@media screen and (max-width: 768px) {
  .vod_icon {
    width: 25px;
    height: 25px;
    background: #fab900;
    border-radius: 50%;
    display: flex;
    align-items: center;
  }
  .sharebtndiv span {
    font-size: 12px;
  }
  .vod_icon svg {
    width: 15px;
    height: 15px;
  }
  .vod_icon_eps {
    width: 40px;
    height: 40px;
    background: #fab900;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vod_icon_eps svg {
    width: 30px;
    height: 30px;
  }
  .title_header {
    font-size: 20px;
  }
  .eps {
    font-size: 12px;
  }
  .mainEpsTitle,
  .eps_player_title {
    font-size: 20px;
  }
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px 0;
  }
}

@media only screen and (max-width: 480px) {
  .sharebtndiv img {
    width: 16px;
  }
}
</style>

<style>
.pagination {
  width: 100%;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background: #191919;
  border-radius: 8px !important;
  padding: 16px 4px !important;
}
.pagination li a,
.pagination li.disabled a {
  background-color: #191919 !important;
  border-color: unset;
  border: unset !important;
  color: #fff !important;
  text-align: center;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  padding: 0 !important;
  margin-left: 0 !important;
  margin: 0 4px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
}

.pagination > li:first-child {
  position: absolute;
  left: 4px;
}

.pagination > li:last-child {
  position: absolute;
  right: 4px;
}
.pagination > li:first-child a,
.pagination > li:last-child a {
  border-radius: 8px !important;
  background: #fab913 !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
  color: #344054 !important;
  padding: 0 8px !important;
  width: fit-content !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

.pagination li a:hover,
.pagination li.disabled a:hover {
  background: green;
  border-color: green;
  color: white;
}

.pagination .active a {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background: #fab913 !important;
  color: #424242 !important;
  font-family: "Poppins", sans-serif !important;
}

@media only screen and (max-width: 480px) {
  .pagination li a,
  .pagination li.disabled a {
    margin-left: 0 !important;
    margin: 0 3px !important;
    width: 20px;
    height: 20px;
    font-size: 12px;
  }
  .pagination > li:first-child a,
  .pagination > li:last-child a {
    border-radius: 4px !important;
    font-size: 12px !important;
    padding: 0 8px 2px !important;
  }
}
/* pagination ends */
</style>
